let ctx = null;

function getContext() {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
}

// Navegadores só liberam áudio após uma interação do usuário — destrava assim que possível.
if (typeof document !== 'undefined') {
  const destravar = () => {
    const c = getContext();
    if (c && c.state === 'suspended') c.resume().catch(() => {});
  };
  document.addEventListener('click', destravar);
  document.addEventListener('keydown', destravar);
}

// Simula o toque mecânico de um telefone de disco antigo: dois "trrrim" curtos em sequência.
export function tocarToqueAntigo() {
  const c = getContext();
  if (!c) return;
  if (c.state === 'suspended') { c.resume().catch(() => {}); return; }

  const now = c.currentTime;
  const gain = c.createGain();
  gain.gain.setValueAtTime(0, now);
  gain.connect(c.destination);

  const osc1 = c.createOscillator();
  const osc2 = c.createOscillator();
  osc1.type = 'sine'; osc1.frequency.value = 425;
  osc2.type = 'sine'; osc2.frequency.value = 480;
  osc1.connect(gain); osc2.connect(gain);

  // Trinado rápido no volume simula a campainha mecânica vibrando
  const trinar = (inicio, duracao) => {
    const passo = 1 / 18;
    for (let t = inicio; t < inicio + duracao; t += passo) {
      gain.gain.setValueAtTime(0.22, t);
      gain.gain.setValueAtTime(0.0001, Math.min(t + passo / 2, inicio + duracao));
    }
  };
  trinar(now, 0.4);
  trinar(now + 0.55, 0.4);

  osc1.start(now); osc2.start(now);
  osc1.stop(now + 1); osc2.stop(now + 1);
}
